import { render, staticRenderFns } from "./DetalleCambioNivelesItem.vue?vue&type=template&id=3de1ba8c&"
import script from "./DetalleCambioNivelesItem.vue?vue&type=script&lang=js&"
export * from "./DetalleCambioNivelesItem.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCambioNivelesItem.vue?vue&type=style&index=0&id=3de1ba8c&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports